// import headerBg from '@/assets/images/active/servitor/circus/header/header_bg.png';
// import headerBg2 from '@/assets/images/active/servitor/circus/header/header_bg2.png';
// import officeBtn from '@/assets/images/active/servitor/circus/header/btn_05.png';
// import loginBtn from '@/assets/images/active/servitor/circus/header/btn_06.png';
// import accountBtn from '@/assets/images/active/servitor/circus/header/btn_07.png';
// import activeBtn from '@/assets/images/active/servitor/circus/header/btn_09.png';
// import logoutBtn from '@/assets/images/active/servitor/circus/header/btn_10.png';

// import headerBg from 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/header.png';
// import headerBg2 from 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/header.png';
// import officeBtn from 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/offcial.png';
// import switchBtn from 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/switch.png';
// import loginBtn from 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/login.png';
// import logoutBtn from '@/assets/images/active/servitor/circus/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/header.png',
    style: '',
    game_name: '使魔计划',
  },
  logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/header.png',
    main_title_color: '#fff',
    sub_title_color: '#fff',
    tips_color: '#fff',
    game_name: '使魔计划',
  },
  operation_btn: {

    login: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/login.png',
      style: 'top: 0.32rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/switch.png',
      style: 'top: 0.32rem',
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/offcial.png',
      style: 'top: 0.32rem',
      link: 'https://smjh.qingcigame.com/leading/'
    },
    logout: {
      width: '',
      height: '',
      img: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/switch.png',
      style: 'top: 0.32rem'
    },
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/offcial.png',
      style: 'top: 0.32rem',
      link: 'https://smjh.qingcigame.com/leading/'
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/servitor/anniversary/headerConfig.js